import { getDomain } from './url-utils';
import { PLAN_TYPE_FREEMIUM } from 'constants/ecommerceConstants';

export const buildEcommerceUrl = (jwt?: string, extraParams?: object) => {
  const ecommerceUrl = new URL(`https://shop.${getDomain()}`);
  if (jwt) {
    ecommerceUrl.searchParams.append('a', jwt);
  }
  for (const param in extraParams) {
    if (extraParams.hasOwnProperty(param)) {
      ecommerceUrl.searchParams.append(param, extraParams[param]);
    }
  }
  ecommerceUrl.searchParams.append('next', `manage.${getDomain()}`);

  return ecommerceUrl.toString();
};

export const getEcommerceAccountUrl = (jwt?: string) => {
  const ecommerceAccountUrl = new URL(`https://ecommerce.${getDomain()}/account`);
  if (jwt) {
    ecommerceAccountUrl.searchParams.append('jwt', jwt);
  }

  return ecommerceAccountUrl.toString();
};

export const mapEcommercePlanType = (plan: string) => {
  return (plan === PLAN_TYPE_FREEMIUM ? 'FREE' : plan);
};
